<template>
    <div class="publish-product-form-images-upload">
        <div class="publish-product-form-images-upload-icon-box">
            <p v-if="asRequired" class="publish-product-form-images-upload-icon">*</p>
        </div>
        <p class="publish-product-form-images-upload-title">商品截图</p>
        <div class="publish-product-form-images-upload-productScreenshot">
            <!-- <ul>
            <div class="publish-product-form-images-upload-btn-box" @click="clickUploadBtnHandler()">
                <img class="publish-product-form-images-upload-btn-icon" src="/images/home/my_center_images_upload_bg.png" alt="上传按钮" >
            </div>
            <li v-for="(item,index) in uploadImages" :key="index" >
                <img class="publish-product-form-images-upload-image-show" :src="item" alt="上传的图片" >
                <img @click="clickDeleteImageHandler(index)" class="publish-product-form-images-upload-image-icon" src="/images/home/my_center_upload_delete_icon.png" alt="删除图片" >
            </li>
        </ul> -->
            <ul>
                <div class="publish-product-form-images-upload-btn-box" @click="clickUploadBtnHandler()">
                    <img class="publish-product-form-images-upload-btn-icon"
                        src="/images/home/my_center_images_upload_bg.png" alt="上传按钮" />
                    <input type="file" accept="image/png, image/jpeg, image/jpg" style="display: none"
                        @change="handleFileUpload" ref="fileInput" />
                </div>
                <li v-for="(item, index) in uploadImages" :key="index">
                    <img class="publish-product-form-images-upload-image-show" :src="item" alt="上传的图片" />
                    <img @click="clickDeleteImageHandler(index)" class="publish-product-form-images-upload-image-icon"
                        src="/images/home/my_center_upload_delete_icon.png" alt="删除图片" />
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { publishProductUploadImage, deletePublishProductScreenshot } from '@/services/publishProduct/index.js';
export default {
    name: "PublishProductFormImagesUpload",
    props: {
        title: {
            type: String,
            default: '',
            required: true
        },
        aliasTitle: {
            type: String,
            default: '',
            required: true
        },
        asRequired: {
            type: Boolean,
            default: false,
            required: true
        },
    },
    data() {
        return {
            uploadImages: [
                // "https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/23e8ce2fd87e4e60bcceb6dbc0b6db04_mergeImage.png",
                // "https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/274c9e84ced14fcca3d21c015be30c09_mergeImage.png",
                // "https://lanhu-dds-backend.oss-cn-beijing.aliyuncs.com/merge_image/imgs/23e8ce2fd87e4e60bcceb6dbc0b6db04_mergeImage.png",

            ],
            maxFileSize: 2 * 1024 * 1024, // 2MB，单位字节
        }
    },
    methods: {
        ...mapMutations('publishProduct', ['setCurrentSelectObjectProperty']),
        //点击删除按钮操作
        clickDeleteImageHandler(index) {
            console.log('当前索引是：' + index)
            //let that = this;
            this.$confirm('确定删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                //删除云端截图
                this.deletePublishProductScreenshotHandler(this.uploadImages[index]);
                //删除本地截图
                this.uploadImages.splice(index, 1);
                let tempData = {
                    itemTitle: this.aliasTitle,
                    itemValue: this.uploadImages
                }
                this.setCurrentSelectObjectProperty(tempData);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除操作'
                });
            });
            this.clearFileInput();
        },
        //删除云端截图
        async deletePublishProductScreenshotHandler(deleteLink) {
            try {
                let tempData = {
                    screenshotLink: deleteLink
                }
                const { data } = await deletePublishProductScreenshot(tempData);
                if (data.code == 200) {
                    this.$message.success('删除截图成功')
                }
            } catch (err) { }
        },
        //点击上传按钮操作
        clickUploadBtnHandler() {
            // 触发 input file 的点击事件
            this.$refs.fileInput.click();
        },
        //真正上传截图方法
        async handleFileUpload(event) {
            const file = event.target.files[0];
            if (!file) {
                return;
            }
            //判断图片格式
            const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg'];
            if (!allowedTypes.includes(file.type)) {
                this.$message.warning('请选择 png, jpeg, 或 jpg 格式的图片!');
                this.clearFileInput();
                return;
            }
            //限制图片大小
            if (file.size > this.maxFileSize) {
                this.$message.warning('图片大小不能超过 2MB!');
                this.clearFileInput();
                return;
            }
            // 使用 FormData 上传文件
            const formData = new FormData();
            formData.append('image', file); // 'image' 是后端接收文件的字段名
            formData.append('handlerType', 'screenshot'); //添加类型属于截图，方便云端起名

            try {
                const { data } = await publishProductUploadImage(formData);
                if (data.code == 200) {
                    this.$message.success('上传成功')
                    this.uploadImages.push(data.data);
                    let tempData = {
                        itemTitle: this.aliasTitle,
                        itemValue: this.uploadImages
                    }
                    this.setCurrentSelectObjectProperty(tempData);
                    this.clearFileInput();
                }
            } catch (error) {
                //console.error('上传出错:', error);
                this.$message.warning('上传出错，请稍后再试!');
                this.clearFileInput();
            }
        },
        //防止下次上传相同的文件名时，失效
        clearFileInput() {
            if (this.$refs.fileInput) {
                this.$refs.fileInput.value = '';
            }
        }
    },
    computed: {
        ...mapState({
            currentSelectObjectProperty: state => state.publishProduct.currentSelectObjectProperty
        })
    },
    mounted() {
        if (this.currentSelectObjectProperty && this.currentSelectObjectProperty[this.aliasTitle]) {
            this.uploadImages = this.currentSelectObjectProperty[this.aliasTitle];
        }
    }
}
</script>

<style lang="less" scoped>
.publish-product-form-images-upload {
    width: 1100px;
    margin-top: 10px;
    background: #FFFFFF;
    margin-left: 50px;
    display: flex;

    .publish-product-form-images-upload-icon-box {
        margin-top: 20px;
        width: 8px;
        height: 21px;

        .publish-product-form-images-upload-icon {
            width: 8px;
            height: 21px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 15px;
            color: #E74335;
            line-height: 21px;
            text-align: left;
            font-style: normal;
            cursor: default;
        }
    }

    .publish-product-form-images-upload-title {
        margin-top: 20px;
        width: 112px;
        margin-left: 6px;
        height: 19px;
        font-family: MicrosoftYaHei, MicrosoftYaHei;
        font-weight: bold;
        font-size: 14px;
        color: #131415;
        line-height: 19px;
        text-align: left;
        font-style: normal;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        cursor: default;
    }

    .publish-product-form-images-upload-productScreenshot {
        margin-left: 24px;
        width: 950px;

        ul {
            list-style-type: none;
            padding: 0px;
            display: flex;
            flex-wrap: wrap;

            .publish-product-form-images-upload-btn-box {
                margin-top: 20px;
                width: 100px;
                height: 100px;
                background: #F5F5F5;
                border-radius: 4px;
                display: flex;
                justify-content: center;
                align-items: center;

                .publish-product-form-images-upload-btn-icon {
                    width: 26px;
                    height: 24px;
                }
            }

            li {
                margin-top: 20px;
                margin-left: 20px;
                list-style: none;
                width: 100px;
                height: 100px;
                background: #F5F5F5;
                border-radius: 4px;
                position: relative;
                padding: 0px;

                .publish-product-form-images-upload-image-show {
                    width: 100px;
                    height: 100px;
                }

                .publish-product-form-images-upload-image-icon {
                    width: 20px;
                    height: 20px;
                    position: absolute;
                    right: 0px;
                    top: 0px;
                }

                &:nth-child(8n+1) {
                    margin-left: 0px;
                }
            }
        }
    }

}
</style>